// Only Perm Features (Should be marked as a permanent flag in LaunchDarkly)
export const FeatureFlags = {
  AdditionalBlogUrls: 'Web.AdditionalBlogUrls',
  AgentLanderUrl: 'Web.AgentLanderUrl',
  AgentLandingPartnerships: 'Web.AgentLandingPartnerships',
  AircallPhoneNumbers: 'Web.AircallPhoneNumbers',
  AwardsConfig: 'Web.AwardsConfig',
  AwardsCurrentYear: 'Awards.CurrentYear',
  BrandFooterLink: 'Web.FooterBrandUrl',
  BrokerageAttribution: 'Web.BrokerageAttribution',
  ContactSalesPhoneNumber: 'Web.ContactSalesPhoneNumber',
  ContactUsUrl: 'Web.ContactUsUrl',
  CorporatePlans: 'Web.CorporatePlans',
  DashboardEnableCorporateLeaderboard: 'Dashboard.EnableCorporateLeaderboard',
  DisableCloudinary: 'Web.DisableCloudinary',
  EnableBuyerAgents: 'Core.EnableBuyerAgents',
  EnableCustomAds: 'Web.EnableCustomAds',
  EnableFinance: 'Core.EnableFinance',
  EnableFreeTrialCta: 'Public.EnableFreeTrialCta',
  EnableHomepageAgentCta: 'EnableHomepageAgentCta',
  EnableHomepageCaseStudies: 'EnableHomepageCaseStudies',
  EnableImageCaching: 'Web.EnableImageCache',
  EnableIntercom: 'Web.EnableIntercomLiveChat',
  EnableLeadAgentDisclaimer: 'Web.EnableLeadAgentDisclaimer',
  EnableLeasing: 'Web.EnableLeasing',
  EnableListingAttribution: 'Web.EnableListingAttribution',
  EnableMlsFooterLink: 'Web.ShowMlsLicensingFooterLink',
  EnableMobileNumberForMarketReport: 'Core.EnableMobileNumberForMarketReport',
  EnableNewOfficeSubscriptions: 'Web.EnableNewOfficeSubscriptions',
  EnableSettlementPeriod: 'Core.EnableSettlementPeriod',
  EnableTeams: 'Core.EnableTeams',
  EnableUnrequestedReviews: 'Core.EnableUnrequestedReviews',
  FaqFooterLink: 'Web.FooterFaqUrl',
  FeaturedVideoReviews: 'Web.FeaturedVideoReviews',
  FindMyAgentPopupBanner: 'FindMyAgent.PopupBanner',
  FindMyAgentPropertyTypes: 'FindMyAgent.PropertyTypes',
  FindMyAgentSearchBanner: 'FindMyAgent.SearchBanner',
  FloatingHeads: 'Web.ConsumerHomeFloatingHeads',
  FooterAwardsUrl: 'Web.FooterAwardsUrl',
  FooterShowSupportEmailToUnsubscribedUsers: 'Web.FooterShowSupportEmailToUnsubscribedUsers',
  FooterShowSupportNumberToUnsubscribedUsers: 'Web.FooterShowSupportNumberToUnsubscribedUsers',
  HasMandatoryLicenceField: 'HasMandatoryLicenceField',
  HideAddressSearch: 'Public.HideAddressSearch',
  HomePageBrokerageLink: 'Web.HomePageBrokerageLink',
  HomepageSearchImage: 'Web.HomepageSearchImage',
  MarketingBaseUrl: 'Web.MarketingBaseUrl',
  PropertyTypeGrouping: 'Web.PropertyTypeGrouping',
  SaleMethodInsights: 'Web.SaleMethodInsights',
  ShowReviewsOnListingLandingPages: 'LandingPages.Listing.ShowReviews',
  SubscriptionTierChannels: 'Web.SubscriptionPlanIntegrations',
  SupportCentreUrl: 'Core.SupportCentreUrl',
  SupportEmail: 'Web.SupportEmail',
  TeamsBillingGrouping: 'Web.TeamsBillingGrouping',
  TrainingWebinarUrl: 'TrainingWebinarUrl',
  TypeformSurvey2023Snippet: 'Web.TypeformSurvey2023Snippet',
  UseSourceListingStatus: 'Core.UseSourceListingStatus',
} as const;

// Temporary Features
export const TempFeatureFlags = {
  EnableBrokerageProInterestCheck: 'Temp.EnableBrokerageProInterestCheck',
  HideDom: 'Temp.Public.HideDOM2023',
  OfficeSubscriptionContactRequest: 'Web.OfficeSubscriptionContactRequest',
  SpanishReviews: 'Temp.EnableSpanishReviewFlow',
  CreateProfileTrackCountryIndustryRole: 'Temp.CreateProfileTrackCountryIndustryRole',
  ConsumerSurveyId2025: 'ConsumerSurveyId2025',
  ShowNewComparisonTable: 'Temp.ShowNewPlanComparisonTable',
} as const;

// Experiments Features
export const ExperimentFlags = {
  NlpSearch: 'Experiment.NlpSearch',
} as const;

type PermanentFlag = (typeof FeatureFlags)[keyof typeof FeatureFlags];
type TemporaryFlag = (typeof TempFeatureFlags)[keyof typeof TempFeatureFlags];
export type ExperimentFlag = (typeof ExperimentFlags)[keyof typeof ExperimentFlags];

export type FeatureFlag = PermanentFlag | TemporaryFlag | ExperimentFlag;
